import React from "react";
import _ from "lodash";
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";

import withStyles from "@material-ui/core/styles/withStyles";

import PbButton from "../PbButton";
import PrimaryButton from "../../../../components/Buttons/PrimaryButton";
import CompareIcon from "../../../../images/CompareIcon";
import BaseDialog from "../../../../components/BaseDialog/BaseDialog";
import CustomersNew from "../../../../components/CustomersSelectorProviderNew/CustomersNew";
import {AGGREGATED_PORTFOLIO_ID, onboardingOnCustomersChange} from "../../../../utils/utils";
import {OBJECT_TYPES} from "../../../RiskProfiling/constants";
import {OnboardingButtonAttributesHelper} from "../../../CustomerDashboardV2/utils";
import {SelectCustomerDepotsForPortfolioBuilderModal} from "../../../CustomerDashboardV2/components_v2/PortfolioBuilderDepotModal/PortfolioBuilderDepotModal";
import {parseResponse, PortfolioHandlerResource, QuestionnairesHandlerResource} from "../../../../utils/api";
import {hasPortfolios} from "../../../../components/CustomersSelectorProviderNew/utils";
import {getInvestmentPlatformSelector} from "../../../../utils/redaxSelectors";
import {getBanksCompanyIdToCodeMapping} from "../../../Trades/utils";
import {SESSION_EXISTS_MSG} from "../../constants";

import styles from "./styles";


const CustomerDepotSelectionModal = (props) => {
  const {classes, setLoading} = props;

  const [open, setOpen] = React.useState(false);
  const [selectedCustomer, setSelectedCustomer] = React.useState(undefined);
  const [instrumentsData, setInstrumentsData] = React.useState({
    loading: false,
    data: undefined,
  });

  const handlePtfDataError = () => {

  };

  React.useEffect(() => {
    if(selectedCustomer){
      setInstrumentsData({...instrumentsData, loading: true});

      PortfolioHandlerResource.getCustomerAppData(selectedCustomer.customer_id, false)
        .then((res) => {
          parseResponse(res, 'customer', (data) => {

            const depots = _.get(data, 'portfolios.portfolios', []).filter(
              p => p.depotNumber != AGGREGATED_PORTFOLIO_ID);

            setInstrumentsData({
              data: depots.map(p => ({...p, id: p.depotNumber})),
              loading: false,
              updatedAt: +new Date()
            });
          }, handlePtfDataError)
        }).catch(handlePtfDataError)
    }

  }, [selectedCustomer]);

  const combinedTradings = React.useRef({});
  const banksData = React.useRef();
  const banksMappingData = React.useRef();

  const onCustomersChange = async (customers) => {
    combinedTradings.current = await onboardingOnCustomersChange(customers, OBJECT_TYPES.COMBINED);

    if(!banksData.current){
      const res = await QuestionnairesHandlerResource.getBanksData();
      banksData.current = res.response;
    }
    if(!banksMappingData.current) {
      banksMappingData.current = await getBanksCompanyIdToCodeMapping();
    }
  };

  const extraColumns = React.useMemo(() => {
    return [{
      content: [{
        header: '',
        body: {
          content: (customer) => {
            let tooltip;
            let disabled;
            if(!hasPortfolios(customer)){
              disabled = true
            } else if(OnboardingButtonAttributesHelper.isOnboardingProcessStarted(combinedTradings.current[customer.id])){
              disabled = true;
              tooltip = SESSION_EXISTS_MSG;
            }

            return (
              <PrimaryButton
                icon={<CompareIcon color={'currentColor'} />}
                iconPosition={'right'}
                variant={'text'}
                text={'Portfolio-Builder'}
                disabled={disabled}
                tooltip={tooltip}
                onButtonClick={() => setSelectedCustomer(customer)}
              />
            )
          },
          className: 'extraButton',
        }
      }]
    }]
  }, []);

  const goToTradeDetails = async () => {
    setLoading(true);

    await OnboardingButtonAttributesHelper.startNewTrading(
      selectedCustomer, banksData.current, banksMappingData.current, props
    );

    setLoading(false);
  };

  return (
    <>
      <PbButton text={'Bestehendes Depot ändern'} onClick={() => setOpen(true)} />
      <BaseDialog
        open={open}
        title={"Kundenübersicht"}
        handleClose={() => setOpen(false)}
        customClasses={{dialogContent: classes.dialogContent}}
      >
        <CustomersNew
          extraColumns={extraColumns}
          withHeader={false}
          onCustomersChange={onCustomersChange}
        />
      </BaseDialog>
      <SelectCustomerDepotsForPortfolioBuilderModal
        instrumentsData={instrumentsData}
        completlySold={{}}
        onlyDepots
        open={!!selectedCustomer}
        onClose={() => setSelectedCustomer(undefined)}
        customerId={_.get(selectedCustomer, 'customer_id')}
        banksData={banksData.current}
        onGoToTradeDetails={goToTradeDetails}
      />
    </>
  )
};

const mapStateToProps = (state) => ({
  investmentPlatform: getInvestmentPlatformSelector(state),
});

export default withRouter(connect(mapStateToProps)(withStyles(styles)(CustomerDepotSelectionModal)));